import { Action } from '../../../shared/xs/actions';

export class CountryInitAction implements Action {
  static readonly type = '[Auth] Country Init';

  constructor(public payload: { country: string }) {}
}
